<template>
  <CRow style="padding-bottom: 200px">
    <CCol class="py-2">
      <CForm autocomplete="OFF" @submit.prevent="updateOrganization">
        <!-- INFO -->
        <CRow class>
          <CCol class="h-100">
            <h4 class="mb-3 font-weight-normal">{{ $t('settings.organization.formOrganization.title.info') }}</h4>
            <div class="border-line"></div>
          </CCol>
        </CRow>
        <!--<button @click="getOrganizationBalanceTypes">AAA</button>-->

        <!-- Primeira Linha -->
        <CRow class="mt-2">
          <CCol>
            <CInput
              class="mb-0"
              :maxlength="$v.organization.companyName.$params.maxLength.max"
              :label="$t('settings.organization.formOrganization.form.input-label.company-name')"
              addLabelClasses="mt-1 required"
              :value.sync="$v.organization.companyName.$model"
              :invalidFeedback="assignInvalidFeedback($v.organization.companyName)"
              :isValid="checkIfValid('companyName')"
              id="companyName"
              placeholder
              :disabled="!edit"
            />
          </CCol>

          <CCol>
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.phone-number') }}
                </label>
              </CCol>
              <CCol sm="12">
                <CRow sm="12" class="d-flex" :gutters="false">
                  <CCol sm="4" class="mr-1">
                    <v-select
                      class="mb-0 no-close"
                      :class="{ 'is-invalid': $v.organization.phoneCountryIndicator.$error }"
                      :options="optionsCountries"
                      v-model="$v.organization.phoneCountryIndicator.$model"
                      :isValid="checkIfValid('phoneCountryIndicator')"
                      id="countrySelected"
                      :disabled="!edit"
                      :placeholder="$t('general.input.placeholder.country-code')"
                    >
                      <template #selected-option="{ label, flag }">
                        <div class="d-flex align-items-center">
                          <img :src="flag" alt width="25" />
                          <span class="ml-2">{{ label }}</span>
                        </div>
                      </template>
                      <template v-slot:option="option">
                        <img :src="option.flag" width="20" height="auto" />
                        {{ option.label }}
                      </template>
                    </v-select>
                    <div class="error invalid-feedback" v-if="$v.organization.$error && $v.organization.phoneCountryIndicator.$invalid">
                      {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                    </div>
                  </CCol>
                  <CCol>
                    <CInput
                      type="text"
                      name="phoneNumber"
                      id="phoneNumber"
                      addInputClasses="pr-2"
                      :maxlength="$v.organization.phoneNumber.$params.maxLength.max"
                      @keypress="isNumber($event)"
                      :value.sync="$v.organization.phoneNumber.$model"
                      :isValid="checkIfValid('phoneNumber')"
                      :invalidFeedback="assignInvalidFeedback($v.organization.phoneNumber)"
                      :disabled="!edit"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <!-- Segunda Linha -->
        <CRow class="mt-2">
          <CCol col="6">
            <CInput
              class="mb-0"
              :label="$t('settings.organization.formOrganization.form.input-label.email')"
              addLabelClasses="mt-1 required"
              :value.sync="$v.organization.email.$model"
              :invalidFeedback="assignInvalidFeedback($v.organization.email)"
              :isValid="checkIfValid('email')"
              id="email"
              placeholder
              :disabled="!edit"
            />
          </CCol>
          <CCol v-if="!hasValueOrganizationTypeClient">
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.type-of-account') }}
                </label>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <v-select
                  class="mb-0 no-close"
                  addLabelClasses="mt-1 required"
                  :class="{ 'is-invalid': $v.organization.businessArea.$error }"
                  v-model="$v.organization.organizationType.$model"
                  :isValid="checkIfValid('organizationType')"
                  :options="organizationTypes"
                  :invalidFeedback="assignInvalidFeedback($v.organization.organizationType)"
                  id="organizationType"
                  :placeholder="$t('general.input.placeholder.select-one')"
                  :disabled="!edit"
                  @input="loadOrganizationBalanceConfigTypes()"
                >
                  <template #selected-option="{ label }">
                    <span class="ml-2" :key="label">{{ label }}</span>
                  </template>
                  <template v-slot:option="option">
                    <span>{{ option.label }}</span>
                  </template>
                </v-select>
                <div class="error invalid-feedback" v-if="$v.organization.$error && $v.organization.organizationType.$invalid">
                  {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <!-- Terceira Linha -->
        <CRow class="mt-4">
          <CCol>
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.business-area') }}
                </label>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <v-select
                  class="mb-0 no-close"
                  addLabelClasses="mt-1 required"
                  :class="{ 'is-invalid': $v.organization.businessArea.$error }"
                  v-model="$v.organization.businessArea.$model"
                  :isValid="checkIfValid('businessArea')"
                  :options="optionsBusinnesArea"
                  :invalidFeedback="assignInvalidFeedback($v.organization.businessArea)"
                  id="businessArea"
                  :placeholder="$t('settings.organization.formOrganization.form.placeholder.businessArea')"
                  :disabled="!edit"
                  v-if="reloadField"
                >
                  <template #selected-option="{ label }">
                    <span class="ml-2" :key="label">{{ label }}</span>
                  </template>
                  <template v-slot:option="option">
                    <span>{{ option.label }}</span>
                  </template>
                </v-select>
                <div class="error invalid-feedback" v-if="$v.organization.$error && $v.organization.businessArea.$invalid">
                  {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                </div>
              </CCol>
            </CRow>
          </CCol>
          <CCol>
            <CInput
              class="mb-0"
              :label="$t('settings.organization.formOrganization.form.input-label.numberEmployes')"
              type="number"
              addLabelClasses="mt-1"
              :value.sync="organization.employees"
              id="employees"
              :disabled="!edit"
              min="0"
            />
          </CCol>
        </CRow>

        <!-- Quarta linha -->
        <CRow class="mt-4">
          <CCol sm="6">
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.business-profile') }}
                </label>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <v-select
                  class="mb-0 no-close"
                  addLabelClasses="mt-1 required"
                  :class="{ 'is-invalid': $v.organization.businessProfile.$error }"
                  v-model="$v.organization.businessProfile.$model"
                  :isValid="checkIfValid('businessProfile')"
                  :options="optionsBusinnesProfile"
                  :invalidFeedback="assignInvalidFeedback($v.organization.businessProfile)"
                  id="businessProfile"
                  :placeholder="$t('settings.organization.formOrganization.form.input-label.business-profile')"
                  :disabled="!edit"
                  v-if="reloadField"
                >
                  <template #selected-option="{ label }">
                    <span class="ml-2" :key="label">{{ label }}</span>
                  </template>
                  <template v-slot:option="option">
                    <span>{{ option.label }}</span>
                  </template>
                </v-select>
                <div class="error invalid-feedback" v-if="$v.organization.$error && $v.organization.businessProfile.$invalid">
                  {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                </div>
              </CCol>
            </CRow>
          </CCol>
        </CRow>

        <!-- CONTACT DETAILS -->
        <CRow class="mt-5">
          <CCol class="h-100">
            <h4 class="mb-3 font-weight-normal">
              {{ $t('settings.organization.formOrganization.title.contact-details') }}
            </h4>
            <div class="border-line"></div>
          </CCol>
        </CRow>

        <h5 style="font-size: 16px" class="mb-3 mt-4 font-weight-normal">
          {{ $t('settings.organization.formOrganization.form.input-label.mainContact') }}
        </h5>
        <div class="border-line"></div>
        <CRow class="mt-2"
          ><!-- MAIN CONTACT -->
          <CCol>
            <CInput
              class="mb-0"
              :label="$t('settings.organization.formOrganization.form.input-label.name')"
              addLabelClasses="mt-1 required"
              :value.sync="$v.organization.contactName.$model"
              :invalidFeedback="assignInvalidFeedback($v.organization.contactName)"
              :isValid="checkIfValid('contactName')"
              :maxlength="$v.organization.contactName.$params.maxLength.max"
              :disabled="!edit"
            />
          </CCol>
          <CCol>
            <CInput
              class="mb-0"
              :label="$t('settings.organization.formOrganization.form.input-label.email')"
              addLabelClasses="mt-1 required"
              :value.sync="$v.organization.contactEmail.$model"
              :invalidFeedback="assignInvalidFeedback($v.organization.contactEmail)"
              :isValid="checkIfValid('contactEmail')"
              id="contactEmail"
              :disabled="!edit"
              placeholder
            />
          </CCol>
          <CCol>
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.phone-number') }}
                </label>
              </CCol>
              <CCol sm="12">
                <CRow sm="12" class="d-flex" :gutters="false">
                  <CCol sm="5" class="mr-1">
                    <v-select
                      class="mb-0 no-close"
                      :options="optionsCountries"
                      :class="{ 'is-invalid': $v.organization.contactPhoneCountryIndicator.$error }"
                      v-model="$v.organization.contactPhoneCountryIndicator.$model"
                      :isValid="checkIfValid('contactPhoneCountryIndicator')"
                      id="contactPhoneCountryIndicator"
                      :disabled="!edit"
                      :placeholder="$t('general.input.placeholder.country-code')"
                    >
                      <template #selected-option="{ label, flag }">
                        <div class="d-flex align-items-center">
                          <img :src="flag" alt width="25" />
                          <span class="ml-2">{{ label }}</span>
                        </div>
                      </template>
                      <template v-slot:option="option">
                        <img :src="option.flag" width="20" height="auto" />
                        {{ option.label }}
                      </template>
                    </v-select>
                    <div class="error invalid-feedback" v-if="$v.organization.$error && $v.organization.phoneCountryIndicator.$invalid">
                      {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                    </div>
                  </CCol>
                  <CCol>
                    <CInput
                      type="text"
                      name="contactPhoneNumber"
                      id="contactPhoneNumber"
                      addInputClasses="pr-2"
                      @keypress="isNumber($event)"
                      :maxlength="$v.organization.contactPhoneNumber.$params.maxLength.max"
                      :value.sync="$v.organization.contactPhoneNumber.$model"
                      :isValid="checkIfValid('contactPhoneNumber')"
                      :invalidFeedback="assignInvalidFeedback($v.organization.contactPhoneNumber)"
                      :disabled="!edit"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <!-- MAIN CONTACT -->
        <h5 style="font-size: 16px" class="mb-3 mt-2 font-weight-normal">
          {{ $t('settings.organization.formOrganization.form.input-label.financial-contact') }}
        </h5>
        <div class="border-line"></div>
        <CRow class="mt-2"
          ><!-- FINANCIAL CONTACT -->
          <CCol>
            <CInput
              class="mb-0"
              :label="$t('settings.organization.formOrganization.form.input-label.name')"
              addLabelClasses="mt-1 "
              :value.sync="$v.organization.contactFinancialName.$model"
              :invalidFeedback="assignInvalidFeedback($v.organization.contactFinancialName)"
              :disabled="!edit"
            />
          </CCol>
          <CCol>
            <CInput
              class="mb-0"
              :label="$t('settings.organization.formOrganization.form.input-label.email')"
              addLabelClasses="mt-1 "
              :value.sync="$v.organization.contactFinancialEmail.$model"
              :disabled="!edit"
              placeholder
            />
          </CCol>
          <CCol>
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.phone-number') }}
                </label>
              </CCol>
              <CCol sm="12">
                <CRow sm="12" class="d-flex" :gutters="false">
                  <CCol sm="5" class="mr-1">
                    <v-select
                      class="mb-0 no-close"
                      :options="optionsCountries"
                      :class="{ 'is-invalid': $v.organization.contactFinancialPhoneCountryIndicator.$error }"
                      v-model="$v.organization.contactFinancialPhoneCountryIndicator.$model"
                      :isValid="checkIfValid('contactPhoneCountryIndicator')"
                      id="contactPhoneCountryIndicator"
                      :disabled="!edit"
                      :placeholder="$t('general.input.placeholder.country-code')"
                    >
                      <template #selected-option="{ label, flag }">
                        <div class="d-flex align-items-center">
                          <img :src="flag" alt width="25" />
                          <span class="ml-2">{{ label }}</span>
                        </div>
                      </template>
                      <template v-slot:option="option">
                        <img :src="option.flag" width="20" height="auto" />
                        {{ option.label }}
                      </template>
                    </v-select>
                    <div class="error invalid-feedback" v-if="$v.organization.$error && $v.organization.phoneCountryIndicator.$invalid">
                      {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                    </div>
                  </CCol>
                  <CCol>
                    <CInput
                      type="text"
                      name="contactFinancialPhoneNumber"
                      id="contactFinancialPhoneNumber"
                      addInputClasses="pr-2"
                      @keypress="isNumber($event)"
                      :isValid="checkIfValid('contactFinancialPhoneNumber')"
                      :maxlength="$v.organization.contactFinancialPhoneNumber.$params.maxLength.max"
                      :value.sync="$v.organization.contactFinancialPhoneNumber.$model"
                      :disabled="!edit"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <!-- FINANCIAL CONTACT -->
        <h5 style="font-size: 16px" class="mb-3 mt-2 font-weight-normal">
          {{ $t('settings.organization.formOrganization.form.input-label.it-contact') }}
        </h5>
        <div class="border-line"></div>
        <CRow class="mt-2"
          ><!-- IT CONTACT -->
          <CCol>
            <CInput
              class="mb-0"
              :label="$t('settings.organization.formOrganization.form.input-label.name')"
              addLabelClasses="mt-1 "
              :value.sync="$v.organization.contactITName.$model"
              :invalidFeedback="assignInvalidFeedback($v.organization.contactITName)"
              :disabled="!edit"
            />
          </CCol>
          <CCol>
            <CInput
              class="mb-0"
              :label="$t('settings.organization.formOrganization.form.input-label.email')"
              addLabelClasses="mt-1 "
              :value.sync="$v.organization.contactITEmail.$model"
              :disabled="!edit"
              placeholder
            />
          </CCol>
          <CCol>
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.phone-number') }}
                </label>
              </CCol>
              <CCol sm="12">
                <CRow sm="12" class="d-flex" :gutters="false">
                  <CCol sm="5" class="mr-1">
                    <v-select
                      class="mb-0 no-close"
                      :options="optionsCountries"
                      :class="{ 'is-invalid': $v.organization.contactITPhoneCountryIndicator.$error }"
                      v-model="$v.organization.contactITPhoneCountryIndicator.$model"
                      :isValid="checkIfValid('contactPhoneCountryIndicator')"
                      id="contactPhoneCountryIndicator"
                      :disabled="!edit"
                      :placeholder="$t('general.input.placeholder.country-code')"
                    >
                      <template #selected-option="{ label, flag }">
                        <div class="d-flex align-items-center">
                          <img :src="flag" alt width="25" />
                          <span class="ml-2">{{ label }}</span>
                        </div>
                      </template>
                      <template v-slot:option="option">
                        <img :src="option.flag" width="20" height="auto" />
                        {{ option.label }}
                      </template>
                    </v-select>
                    <div class="error invalid-feedback" v-if="$v.organization.$error && $v.organization.phoneCountryIndicator.$invalid">
                      {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                    </div>
                  </CCol>
                  <CCol>
                    <CInput
                      type="text"
                      name="contactITPhoneNumber"
                      id="contactITPhoneNumber"
                      addInputClasses="pr-2"
                      @keypress="isNumber($event)"
                      :maxlength="$v.organization.contactITPhoneNumber.$params.maxLength.max"
                      :value.sync="$v.organization.contactITPhoneNumber.$model"
                      :disabled="!edit"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <!-- IT CONTACT -->

        <!-- BILLING -->
        <CRow class="mt-5">
          <CCol class="h-100">
            <h4 class="mb-3 font-weight-normal">
              {{ $t('settings.organization.formOrganization.title.billing') }}
            </h4>
            <div class="border-line"></div>
            <h5 style="font-size: 16px" class="mt-4 mb-2 font-weight-normal" v-if="isShow">
              {{ $t('settings.organization.formOrganization.form.input-label.useMainAccountBilling') }}
              <ToogleSwitch class="ml-2" :stateSwith="organization.isUsingParentBillingInfo" @toggle-switch="changeSelectVal" />
            </h5>
          </CCol>
        </CRow>

        <CRow class="mt-2 pt-1">
          <CCol>
            <CInput
              class="mb-0"
              addLabelClasses="mt-1 required"
              :label="$t('settings.organization.formOrganization.form.input-label.social-designation')"
              :disabled="!edit || organization.isUsingParentBillingInfo"
              :value.sync="$v.organization.billingInfo.name.$model"
              :isValid="checkIfValid('billingInfo.name')"
              :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo)"
            />
          </CCol>
          <CCol>
            <CInput
              class="mb-0"
              addLabelClasses="mt-1 required"
              :label="$t('settings.organization.formOrganization.form.input-label.nif')"
              @keypress="isNumber($event)"
              :disabled="!edit || organization.isUsingParentBillingInfo"
              :value.sync="$v.organization.billingInfo.taxIdentificationNumber.$model"
              :maxlength="$v.organization.billingInfo.taxIdentificationNumber.$params.maxLength.max"
              :isValid="checkIfValid('billingInfo.taxIdentificationNumber')"
              :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.taxIdentificationNumber)"
            />
          </CCol>
        </CRow>

        <CRow class="mt-2 pt-1">
          <CCol>
            <CInput
              class="mb-0"
              addLabelClasses="mt-1 required"
              :label="$t('settings.organization.formOrganization.form.input-label.Address')"
              :disabled="!edit || organization.isUsingParentBillingInfo"
              :value.sync="$v.organization.billingInfo.address.$model"
              :isValid="checkIfValid('billingInfo.address')"
              :maxlength="$v.organization.billingInfo.address.$params.maxLength.max"
              :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.address)"
            />
          </CCol>
          <CCol>
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom mt-1 required">
                  {{ $t('settings.organization.formOrganization.form.input-label.zip-code') }}
                </label>
              </CCol>
            </CRow>
            <CRow :gutters="false">
              <CCol class="pr-1">
                <CInput
                  class="mb-0"
                  addLabelClasses="mt-1 required"
                  :disabled="!edit || organization.isUsingParentBillingInfo"
                  :maxlength="$v.organization.billingInfo.postalCode.$params.maxLength.max"
                  :value.sync="$v.organization.billingInfo.postalCode.$model"
                  :isValid="checkIfValid('billingInfo.postalCode')"
                  :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.postalCode)"
                />
              </CCol>
              <!-- <CCol class="pr-1">
                <CInput
                  class="mb-0"
                  addLabelClasses="mt-1 required"
                  placeholder="Country"
                  :disabled="!edit"
                  :value.sync="$v.organization.billingInfo.country.$model"
                  :isValid="checkIfValid('billingInfo.country')"
                  :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.country)"
                />
              </CCol> -->
              <!-- <CCol>
                <CInput
                  class="mb-0"
                  addLabelClasses="mt-1 required"
                  placeholder="City"
                  :disabled="!edit"
                  :value.sync="$v.organization.billingInfo.city.$model"
                  :isValid="checkIfValid('billingInfo.country')"
                  :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.country)"
                />
              </CCol> -->
            </CRow>
          </CCol>
        </CRow>

        <CRow class="mt-2 pt-1">
          <CCol sm="6">
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.phone-number') }}
                </label>
              </CCol>
              <CCol sm="12">
                <CRow sm="12" class="d-flex" :gutters="false">
                  <CCol sm="4" class="mr-1">
                    <v-select
                      class="mb-0 no-close"
                      :options="optionsCountries"
                      :class="{ 'is-invalid': $v.organization.billingInfo.phoneCountryIndicator.$error }"
                      id="contactPhoneCountryIndicator"
                      :disabled="!edit || organization.isUsingParentBillingInfo"
                      :placeholder="$t('general.input.placeholder.country-code')"
                      v-model="$v.organization.billingInfo.phoneCountryIndicator.$model"
                      :isValid="checkIfValid('billingInfo.phoneCountryIndicator')"
                      :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.phoneCountryIndicator)"
                    >
                      <template #selected-option="{ label, flag }">
                        <div class="d-flex align-items-center">
                          <img :src="flag" alt width="25" />
                          <span class="ml-2">{{ label }}</span>
                        </div>
                      </template>
                      <template v-slot:option="option">
                        <img :src="option.flag" width="20" height="auto" />
                        {{ option.label }}
                      </template>
                    </v-select>
                    <div
                      class="error invalid-feedback"
                      v-if="$v.organization.billingInfo.$error && $v.organization.billingInfo.phoneCountryIndicator.$invalid"
                    >
                      {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                    </div>
                  </CCol>
                  <CCol>
                    <CInput
                      type="text"
                      name="phoneNumber"
                      id="phoneNumber"
                      addInputClasses="pr-2"
                      :maxlength="$v.organization.billingInfo.phoneNumber.$params.maxLength.max"
                      @keypress="isNumber($event)"
                      :disabled="!edit || organization.isUsingParentBillingInfo"
                      :value.sync="$v.organization.billingInfo.phoneNumber.$model"
                      :isValid="checkIfValid('billingInfo.phoneNumber')"
                      :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.phoneNumber)"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="6">
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="country" class="label-custom required mt-1">
                  {{ $t('settings.organization.formOrganization.form.input-label.country-city') }}
                </label>
              </CCol>
            </CRow>
            <CRow :gutters="false">
              <CCol class="mr-1">
                <v-select
                  class="mb-0 no-close"
                  addLabelClasses="mt-1 required"
                  :class="{ 'is-invalid': $v.organization.billingInfo.country.$error }"
                  v-model="$v.organization.billingInfo.country.$model"
                  :isValid="checkIfValid('billingInfo.country')"
                  :options="optionsCountriesNames"
                  :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.country)"
                  id="country"
                  :placeholder="$t('general.input.placeholder.country')"
                  :disabled="!edit || organization.isUsingParentBillingInfo"
                  @input="inputCountry"
                  v-if="reloadField"
                >
                  <template #selected-option="{ label }">
                    <span class="ml-2" :key="label">{{ label }}</span>
                  </template>
                  <template v-slot:option="option">
                    <span>{{ option.label }}</span>
                  </template>
                </v-select>
                <div class="error invalid-feedback" v-if="$v.organization.billingInfo.$error && $v.organization.billingInfo.country.$invalid">
                  {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                </div>
              </CCol>
              <CCol>
                <CInput
                  class="mb-0"
                  addLabelClasses="mt-1 required"
                  :placeholder="$t('settings.organization.formOrganization.form.input-placeholder.city')"
                  :disabled="!edit || organization.isUsingParentBillingInfo"
                  :value.sync="$v.organization.billingInfo.city.$model"
                  :isValid="checkIfValid('billingInfo.city')"
                  :maxlength="$v.organization.billingInfo.city.$params.maxLength.max"
                  :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.city)"
                />
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="6">
            <CRow :gutters="false">
              <CCol class="mr-1">
                <CInput
                  class="mb-0"
                  label="Email"
                  addLabelClasses="mt-1 required"
                  :disabled="!edit || organization.isUsingParentBillingInfo"
                  :value.sync="$v.organization.billingInfo.email.$model"
                  :invalidFeedback="assignInvalidFeedback($v.organization.billingInfo.email)"
                  :isValid="checkIfValid('billingInfo.email')"
                  id="billingInfoEmail"
                  placeholder
                />
              </CCol>
            </CRow>
          </CCol>
        </CRow>
        <!-- BILLING -->

        <div v-if="$route.name !== 'createOrganization-default'">
          <CRow class="mt-4">
            <CCol class="h-100">
              <h4 class="mb-3 font-weight-normal">
                <!-- organization.parentBillingInfo != null || $route.name == 'createSubOrganization' -->
                {{ $t('settings.organization.formOrganization.form.input-label.balance-setup') }}
              </h4>
              <div class="border-line"></div>
            </CCol>
          </CRow>

          <CRow class="mb-5 mt-4">
            <CCol class="col-md-5">
              <v-select
                class="mb-0 no-close"
                addLabelClasses="mt-1 required"
                :class="{ 'is-invalid': $v.organization.organizationBalanceConfigType.$error }"
                v-model="$v.organization.organizationBalanceConfigType.$model"
                :options="organizationBalanceConfigTypes"
                :invalidFeedback="assignInvalidFeedback($v.organization.organizationBalanceConfigType)"
                id="organizationType"
                :placeholder="$t('general.input.placeholder.select-one')"
                :disabled="
                  !edit ||
                  $route.name == 'createOrganization-default' ||
                  ($route.name == 'mainOrganization' &&
                    (organization.organizationBalanceConfigType == 'Independent' || organization.organizationBalanceConfigType == 'Independente'))
                "
              >
                <template #selected-option="{ label }">
                  <span class="ml-2" :key="label">{{ label }}</span>
                </template>
                <template v-slot:option="option">
                  <span>{{ option.label }}</span>
                </template>
              </v-select>
              <div class="error invalid-feedback" v-if="$v.organization.$error && $v.organization.organizationBalanceConfigType.$invalid">
                {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
              </div>
            </CCol>
          </CRow>
        </div>

        <!-- <CRow v-if="isEdit" class="mt-2 pt-1 mb-2"> MP-1399-->
        <CRow v-if="!edit && canUserDeleteOrganization" class="mt-2 pt-1 mb-2">
          <CCol sm="9" class="mt-1" style="padding-left: 0px; margin-left: -10px">
            <CRow class="mb-4 mt-4">
              <CCol style="padding-left: 30px">
                <CButton
                  type="button"
                  class="btn btn-primary px-5"
                  @click="openConfirmDeleteUserPopUp"
                  :class="userButtonDeleteAccount ? 'disabled' : false"
                  >{{ $t('settings.organization.formOrganization.form.button.deleteOrganization') }}</CButton
                >
              </CCol>
            </CRow>
            <transition name="fade" v-if="confirmDeleteUserPopUp">
              <div class="dataTable__popUp popUp" style="margin-top: 10px; margin-left: 15px">
                <div class="popUp__body shadow-sm">
                  <div class="confirmationDelete">
                    <div class="confirmationDelete__header">
                      <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                        {{ $t('settings.organization.formOrganization.form.text.confirmDelete1') }}
                        <br />{{ $t('settings.organization.formOrganization.form.text.confirmDelete2') }}
                      </p>
                    </div>
                    <div class="confirmationDelete__footer">
                      <div class="confirmationDelete__actions">
                        <CButton class="confirmationDelete__btn btn btn-primary" @click="openDoubleConfirmDeleteUserPopUp">{{
                          $t('settings.organization.formOrganization.form.text.yes')
                        }}</CButton>
                        <CButton class="confirmationDelete__btn" @click="closeConfirmDeleteUserPopUp">{{
                          $t('settings.organization.formOrganization.form.text.no')
                        }}</CButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <transition name="fade" v-if="doubleConfirmDeleteUserPopUp">
              <div class="dataTable__popUp popUp" style="margin-top: 10px; margin-left: 400px">
                <div class="popUp__body shadow-sm">
                  <div class="confirmationDelete">
                    <div class="confirmationDelete__header">
                      <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                        {{ $t('settings.organization.formOrganization.form.text.typeDelete') }}
                      </p>
                    </div>
                    <div class="confirmationDelete__body mb-4">
                      <input @keyup="enableDeleteAccountButton" type="text" class="form-control" v-model="confirmDeleteAccountText" />
                    </div>
                    <div class="confirmationDelete__footer">
                      <div class="confirmationDelete__actions">
                        <CButton
                          class="confirmationDelete__btn btn btn-primary"
                          @click="deleteOrganization"
                          :class="userButtonDoubleConfirmDeleteAccount ? 'disabled' : false"
                          >{{ $t('settings.organization.formOrganization.form.button.confirmDelete') }}</CButton
                        >
                        <CButton class="confirmationDelete__btn" @click="closeAccountDeleteUserProcess">{{
                          $t('settings.organization.formOrganization.form.button.cancelDelete')
                        }}</CButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
          </CCol>
        </CRow>

        <CRow class="mt-2 pt-1">
          <CCol sm="2">
            <CButton type="submit" :disabled="disableSave" class="btn btn-primary btn-block mt-sm-2 mt-md-4" v-if="edit">{{
              $t('settings.organization.formOrganization.form.button.save')
            }}</CButton>
          </CCol>
        </CRow>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
import ToogleSwitch from '@/components/ToogleSwitch.vue'
import { required, email, numeric, maxLength, requiredIf } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import vSelect from 'vue-select'
import services from '@/services.js'
import services2 from '@/services/services' // foi add depois acho que deveria ser igual as demais.
import organizationService from '../organization-services.js'
import organizationServices from '../organization-services.js'
import { nameCountries, CallingCodeMoreFlag } from '@/utils/countriesUtils.js'
import { getInvalidFeedback } from '@/utils/vuelidate.js'
import { mapGetters } from 'vuex'

export default {
  name: 'Form',
  mixins: [validationMixin],
  components: {
    vSelect,
    ToogleSwitch,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    isOrgRoot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // TODO Remover dados mock
      organizationId: null,
      disableSave: false,
      disableConfirm: false,
      organization: {
        parentOrganizationId: null,
        companyName: '',
        phoneCountryIndicator: '',
        phoneNumber: '',
        email: '',
        organizationType: '',
        businessArea: null,
        businessProfile: '',
        employees: null,
        contactEmail: '',
        contactName: '',
        contactPhoneCountryIndicator: '',
        contactPhoneNumber: '',
        contactFinancialEmail: '',
        contactFinancialName: '',
        contactFinancialPhoneNumber: '',
        contactFinancialPhoneCountryIndicator: '',
        contactITEmail: '',
        contactITName: '',
        contactITPhoneNumber: '',
        contactITPhoneCountryIndicator: '',
        isUsingParentBillingInfo: false,
        organizationBalanceConfigType: null,
        billingInfo: {
          name: '',
          taxIdentificationNumber: '',
          address: '',
          postalCode: '',
          city: '',
          country: '',
          phoneCountryIndicator: '',
          phoneNumber: '',
          email: '',
        },
        deleted: false,
      },
      organizationTypesValues: {
        1: this.$t('settings.organization.formOrganization.form.input-label.consumes-from-parent'),
        2: this.$t('settings.organization.formOrganization.form.input-label.distributed-by-parent'),
        3: this.$t('settings.organization.formOrganization.form.input-label.independent'),
      },
      organizationAux: {}, // Usado para guardar o estado inicial da organization
      reloadField: true,
      organizationTypes: [],
      balanceTypes: [],
      optionsBusinnes: [],
      optionsBusinnesProfile: [],
      doubleConfirmDeleteUserPopUp: false,
      confirmDeleteAccountText: null,
      userButtonDoubleConfirmDeleteAccount: true,
      userButtonDeleteAccount: false,
      confirmDeleteUserPopUp: false,
      optionsCountriesNames: [],
      valueOrganizationType: '',
      organizationBalanceConfigTypes: [],
      billingInfo: {}, //Usado para preservar os dados do billing pois quando clica em create ele limpa o objeto usado na função ON OFF
      canUserCreateOrganization: null,
      organizationBackup: {}, //Backup da organization
    }
  },
  methods: {
    assignInvalidFeedback(validationObj) {
      return getInvalidFeedback(validationObj)
    },
    inputCountry() {
      this.organization.billingInfo.countryId = this.organization.billingInfo.country.value
      this.organization.billingInfo.detailCountry = this.organization.billingInfo.country.detailCountry || this.organization.billingInfo.country.label
    },
    changeSelectVal(val) {
      if (this.isEdit && !this.edit) {
        return
      }

      this.organization.isUsingParentBillingInfo = val

      if (
        typeof this.organization.parentBillingInfo === 'object' &&
        this.organization.parentBillingInfo !== null &&
        this.organization.isUsingParentBillingInfo &&
        this.isEdit
      ) {
        this.organization.billingInfo.address = this.organization.parentBillingInfo.address
        this.organization.billingInfo.city = this.organization.parentBillingInfo.city
        this.organization.billingInfo.country = this.organization.parentBillingInfo.country
        this.organization.billingInfo.countryId = this.organization.parentBillingInfo.countryId
        this.organization.billingInfo.detailCountry = this.organization.parentBillingInfo.detailCountry
        this.organization.billingInfo.email = this.organization.parentBillingInfo.email
        this.organization.billingInfo.name = this.organization.parentBillingInfo.name
        this.organization.billingInfo.phoneNumber = this.organization.parentBillingInfo.phoneNumber
        this.organization.billingInfo.postalCode = this.organization.parentBillingInfo.postalCode
        this.organization.billingInfo.taxIdentificationNumber = this.organization.parentBillingInfo.taxIdentificationNumber
        this.organization.billingInfo.phoneCountryIndicator = this.optionsCountries.find(
          (elm) => elm.value == this.organization.parentBillingInfo.phoneCountryIndicator,
        )
      }

      if (typeof this.billingInfo === 'object' && this.billingInfo !== null && this.organization.isUsingParentBillingInfo && !this.isEdit) {
        this.organization.billingInfo.address = this.billingInfo.address
        this.organization.billingInfo.city = this.billingInfo.city
        this.organization.billingInfo.country = this.billingInfo.country
        this.organization.billingInfo.countryId = this.billingInfo.countryId
        this.organization.billingInfo.detailCountry = this.billingInfo.detailCountry || this.billingInfo.country
        this.organization.billingInfo.name = this.billingInfo.name
        this.organization.billingInfo.email = this.billingInfo.email
        this.organization.billingInfo.phoneNumber = this.billingInfo.phoneNumber
        this.organization.billingInfo.postalCode = this.billingInfo.postalCode
        this.organization.billingInfo.taxIdentificationNumber = this.billingInfo.taxIdentificationNumber
        this.organization.billingInfo.phoneCountryIndicator = this.optionsCountries.find((elm) => elm.value == this.billingInfo.phoneCountryIndicator)
      }
    },
    checkIfValid(fieldName) {
      if (fieldName.indexOf('.') > 0) {
        let array = fieldName.split('.')
        const field = this.$v.organization[array[0]][array[1]]
        if (!field.$dirty) {
          return null
        }
        return !(field.$invalid || null)
      } else {
        const field = this.$v.organization[fieldName]
        if (!field.$dirty) {
          return null
        }
        return !(field.$invalid || null)
      }
    },
    getBusiness(callback) {
      this.message = []
      services
        .businessAreas()
        .then((response) => {
          if (Array.isArray(response.data)) {
            this.optionsBusinnes = response.data.map((elm) => {
              return {
                value: elm.value,
                label: this.$t('settings.organization.formOrganization.form.options.businessArea' + elm.label),
                group: elm.group,
              }
            })
          }
        })
        .catch((err) => {
          this.message.push(err.response)
        })
        .finally(() => {
          // verifica se existe função para executar
          if (callback) callback()
        })
    },
    getOrganizationTypes(callback) {
      let organizationId = this.$store.state.auth.organizationId
      organizationServices
        .getOrganizationTypes(organizationId)
        .then((res) => {
          this.organizationTypes = res.data.data
        })
        .finally(() => {
          if (callback) callback()
        })
    },
    getOrganizationBalanceTypes() {
      let organizationId = null
      let params = {
        organizationType: this.organization.organizationType.value,
        parentOrganizationId: this.$route.params.organizationId,
      }
      if (this.$route.name === 'mainOrganization') {
        organizationId = this.$route.params.organizationId
      }

      return organizationServices.getOrganizationBalanceTypes(organizationId, params)
    },
    getBusinessProfile(callback) {
      services
        .getBusinessProfileList()
        .then((res) => {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].label = res.data[i].label.replace(/([A-Z])/g, ' $1').trim()
          }
          this.optionsBusinnesProfile = res.data

          this.optionsBusinnesProfile = this.optionsBusinnesProfile.map((elm) => {
            return {
              value: elm.value,
              label: this.$t('settings.organization.formOrganization.form.options.businessProfile.' + elm.label),
              group: elm.group,
            }
          })
        })
        .finally(() => {
          if (callback) callback()
        })
    },
    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    loadParentOrganizationInfo() {
      organizationService.getOrganization(this.organizationId).then((res) => {
        this.organization.parentBillingInfo = res.data.data.parentBillingInfo
        this.billingInfo = res.data.data.billingInfo
        this.loadOrganizationBalanceConfigTypes()
      })
    },

    canCreateOrganization() {
      let userId = this.$store.state.auth.user.id
      organizationService.canCreateOrganization(userId).then((res) => {
        this.canUserCreateOrganization = res.data.data
      })
    },

    loadOrganization() {
      // TODO Remover este mock
      organizationService.getOrganization(this.organizationId).then((res) => {
        for (var item in res.data.data) {
          if (item !== 'billingInfo') {
            if (item === 'businessArea') {
              this.organization[item] = this.optionsBusinnesArea.find((elm) => elm.value == res.data.data[item])
              this.reloadFields()
              continue
            }

            if (item === 'businessProfile') {
              this.organization[item] = this.optionsBusinnesProfile.find((elm) => elm.value == res.data.data[item])
              this.reloadFields()
              continue
            }

            if (item === 'organizationType') {
              this.organization[item] = this.organizationTypes.find((elm) => elm.value == res.data.data[item])
              this.reloadFields()
              continue
            }

            if (item === 'phoneCountryIndicator') {
              this.organization[item] = this.optionsCountries.find((elm) => elm.value == res.data.data[item])
              this.reloadFields()
              continue
            }

            if (item === 'contactPhoneCountryIndicator') {
              this.organization[item] = this.optionsCountries.find((elm) => elm.value == res.data.data[item])
              this.reloadFields()
              continue
            }

            if (item === 'country') {
              this.organization[item] = this.optionsCountries.find((elm) => elm.label == res.data.data[item])
              this.reloadFields()
              continue
            }

            this.organization[item] = res.data.data[item]
          } else {
            if (res.data.data.billingInfo) {
              for (var it in res.data.data.billingInfo) {
                if (it === 'phoneCountryIndicator') {
                  this.organization.billingInfo[it] = this.optionsCountries.find((elm) => elm.value == res.data.data.billingInfo[it])
                  this.reloadFields()
                  continue
                }
                this.organization.billingInfo[it] = res.data.data.billingInfo[it]
              }
            }
          }
        }

        this.loadOrganizationBalanceConfigTypes()

        let orgType = this.organizationBalanceConfigTypes.find((elm) => elm.value == this.organization.organizationBalanceConfigType)
        if (orgType != undefined) {
          this.organization.organizationBalanceConfigType = orgType.label
        }

        let mainContact = this.organization.organizationContactDetails.find((elm) => elm.contactDetailsType == 1)
        let financialContact = this.organization.organizationContactDetails.find((elm) => elm.contactDetailsType == 2) || null
        let itContact = this.organization.organizationContactDetails.find((elm) => elm.contactDetailsType == 3) || null
        this.organization.contactName = mainContact.name
        this.organization.contactEmail = mainContact.email
        this.organization.contactPhoneCountryIndicator = this.optionsCountries.find((elm) => elm.value == mainContact.phoneCountryIndicator)
        this.organization.contactPhoneNumber = mainContact.phoneNumber

        if (financialContact) {
          this.organization.contactFinancialName = financialContact?.name
          this.organization.contactFinancialEmail = financialContact?.email
          this.organization.contactFinancialPhoneCountryIndicator = this.optionsCountries.find(
            (elm) => elm.value == financialContact?.phoneCountryIndicator,
          )
          this.organization.contactFinancialPhoneNumber = financialContact?.phoneNumber
        }

        if (itContact) {
          this.organization.contactITName = itContact?.name
          this.organization.contactITEmail = itContact?.email
          this.organization.contactITPhoneCountryIndicator = this.optionsCountries.find((elm) => elm.value == itContact?.phoneCountryIndicator)
          this.organization.contactITPhoneNumber = itContact?.phoneNumber
        }

        this.billingInfo = res.data.data.billingInfo

        this.organizationAux = JSON.parse(JSON.stringify(this.organization))
      })
    },
    reloadFields() {
      // Usado por combobox para evitar problemas de rendereziação
      this.reloadField = false
      this.$nextTick(() => (this.reloadField = true))
    },
    updateOrganization() {
      this.$v.$touch()
      if (!this.isValid) {
        return
      }

      this.organizationBackup = this.organization
      let submitForm = JSON.parse(JSON.stringify(this.organization))
      submitForm.phoneCountryIndicator = submitForm.phoneCountryIndicator.value
      submitForm.organizationType = submitForm.organizationType.value
      submitForm.businessArea = submitForm.businessArea.value
      submitForm.businessProfile = submitForm.businessProfile.value + ''
      submitForm.contactPhoneCountryIndicator = submitForm.contactPhoneCountryIndicator.value
      submitForm.billingInfo.phoneCountryIndicator = Number(submitForm.billingInfo.phoneCountryIndicator.value)
      submitForm.isUsingParentBillingInfo = this.organization.isUsingParentBillingInfo
      submitForm.isUsingDefaultInvoiceInfo = false

      if (
        (this.currentRouteName == 'mainOrganization' || this.currentRouteName == 'createOrganization-default') &&
        submitForm.organizationBalanceConfigType == null
      ) {
        submitForm.organizationBalanceConfigType = 3
      } else {
        submitForm.organizationBalanceConfigType = this.organization.organizationBalanceConfigType.value
      }

      if (typeof this.organization.billingInfo.country === 'object' && this.organization.billingInfo.country !== null) {
        submitForm.billingInfo.country = this.organization.billingInfo.country.label
      } else {
        submitForm.billingInfo.country = this.organization.billingInfo.country
      }

      submitForm.billingInfo.countryId = this.organization.billingInfo.countryId
      submitForm.billingInfo.detailCountry = this.organization.billingInfo.detailCountry

      submitForm.organizationContactDetailsItems = [
        {
          contactDetailsType: 1, //MAIN
          name: this.organization.contactName,
          email: this.organization.contactEmail,
          phoneCountryIndicator: this.organization.contactPhoneCountryIndicator.value,
          phoneNumber: this.organization.contactPhoneNumber,
        },
        {
          contactDetailsType: 2, //FINANCIAL
          name: this.organization?.contactFinancialName || '',
          phoneCountryIndicator: this.organization?.contactFinancialPhoneCountryIndicator.value || 0,
          phoneNumber: this.organization?.contactFinancialPhoneNumber || '',
          email: this.organization?.contactFinancialEmail || '',
        },
        {
          contactDetailsType: 3, //IT
          name: this.organization?.contactITName || '',
          email: this.organization?.contactITEmail || '',
          phoneCountryIndicator: this.organization?.contactITPhoneCountryIndicator.value || 0,
          phoneNumber: this.organization?.contactITPhoneNumber || '',
        },
      ]

      if (this.organization.isUsingParentBillingInfo) {
        //submitForm.billingInfo = null
      }

      if (this.isEdit) {
        // Caso não tenha organizationId vai buscar no state
        if (!this.organizationId) this.organizationId = this.$store.state.auth.organizationId

        this.disableSave = true
        organizationServices
          .updateOrganization(this.organizationId, submitForm)
          .then((res) => {
            this.$emit('organizationChanged', {
              status: 'success',
              text: this.$t('settings.organization.formOrganization.form.messages.successUpdate'),
            })
            // this.loadOrganization();
            window.location.reload()
          })
          .catch(({ response }) => {
            this.$emit('organizationChanged', {
              status: 'danger',
              text: response.data.Message || response.data.message,
            })
          })
          .finally(() => {
            this.disableSave = false
          })
      } else {
        this.disableSave = true
        services
          .createOrganization(submitForm)
          .then((res) => {
            this.$emit('organizationChanged', {
              status: 'success',
              text: this.$t('settings.organization.formOrganization.form.mesages.successCreate'),
            })

            let self = this
            setTimeout(() => {
              self.$store.dispatch('auth/selectOrganization', { value: res.data.data.organizationId }).then((res) => {
                self.$router.push({ name: 'home', params: { organizationId: res.data.data.organizationId } })
              })
            }, 3000)
          })
          .catch(({ response }) => {
            this.$emit('organizationChanged', {
              status: 'danger',
              text: response.data.Message || response.data.message,
            })
          })
          .finally(() => {
            this.disableSave = false
          })
      }
    },
    openConfirmDeleteUserPopUp() {
      this.confirmDeleteUserPopUp = true
      this.userButtonDeleteAccount = true
    },

    closeConfirmDeleteUserPopUp() {
      this.confirmDeleteUserPopUp = false
      this.userButtonDeleteAccount = false

      if (this.doubleConfirmDeleteUserPopUp) {
        this.doubleConfirmDeleteUserPopUp = false
      }
    },

    openDoubleConfirmDeleteUserPopUp() {
      this.doubleConfirmDeleteUserPopUp = true
    },

    deleteAccountUser() {
      this.$router.push({ name: 'Login' })
    },

    closeAccountDeleteUserProcess() {
      this.confirmDeleteUserPopUp = false
      this.userButtonDeleteAccount = false
      this.doubleConfirmDeleteUserPopUp = false
    },

    enableDeleteAccountButton() {
      if (this.confirmDeleteAccountText === 'DELETE') {
        this.userButtonDoubleConfirmDeleteAccount = false
      } else {
        this.userButtonDoubleConfirmDeleteAccount = true
      }
    },

    deleteOrganization() {
      services
        .deleteOrganization(this.$route.params.organizationId, this.$store.state.auth.user.id)
        .then((data) => {
          this.scrollTop()

          this.deleted = data.data.success
          this.$emit('organizationChanged', {
            status: 'success',
            text: 'The organization deleted' || 'Error',
          })
        })
        .catch(({ response }) => {
          this.$emit('organizationChanged', {
            status: 'danger',
            text: response.data.message || 'Error',
          })
        })
        .finally(() => {
          setTimeout(() => {
            this.$route.params.organizationId = ''
            this.$router.replace({ name: 'OrganizationSelection' })
          }, 2000)
        })
    },

    // TODO deixar global
    logout() {
      var UserId = this.$store.state.auth.user.id
      services2
        .logout(UserId)
        .then(() => {
          this.$store.commit('auth/DEFAULT_AUTH_STATE')
          this.$router.push({ name: 'Login' })
        })
        .catch((error) => {
          throw error
        })
    },

    scrollTop: function () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 50)
    },

    enumOrganizationType(num) {
      const typeList = {
        1: 'Sendit',
        2: 'Client',
      }
      return typeList[num] || null
    },

    async getInfoorganization() {
      const response = await services.getOrganization(this.$store.state.auth.organizationId)
      if (!response.data.success) return

      this.valueOrganizationType = this.enumOrganizationType(response.data.data.organizationType)

      if (this.valueOrganizationType == 'Client') this.setOrganizationType()
    },

    setOrganizationType() {
      this.organization.organizationType = {
        value: '2',
        label: 'Client',
        group: null,
      }
    },

    loadOrganizationBalanceConfigTypes() {
      this.getOrganizationBalanceTypes().then((res) => {
        if (Array.isArray(res.data.data)) {
          let result = res.data.data.map((elm) => {
            return {
              value: elm,
              label: this.organizationTypesValues[elm],
            }
          })
          this.organizationBalanceConfigTypes = result

          let orgType = this.organizationBalanceConfigTypes.find((elm) => elm.value == this.organization.organizationBalanceConfigType)
          this.organization.organizationBalanceConfigType = orgType.label
        }
      })

      // if (this.currentRouteName == 'mainOrganization' && this.organization.organizationBalanceConfigType == 3) {
      //   this.organizationBalanceConfigTypes = [
      //     {
      //       value: '1',
      //       label: this.$t('settings.organization.formOrganization.form.input-label.consumes-from-parent'),
      //     },
      //     {
      //       value: '2',
      //       label: this.$t('settings.organization.formOrganization.form.input-label.distributed-by-parent'),
      //     },
      //     {
      //       value: '3',
      //       label: this.$t('settings.organization.formOrganization.form.input-label.independent'),
      //     },
      //   ]
      // } else {
      //   this.organizationBalanceConfigTypes = [
      //     {
      //       value: '1',
      //       label: this.$t('settings.organization.formOrganization.form.input-label.consumes-from-parent'),
      //     },
      //     {
      //       value: '2',
      //       label: this.$t('settings.organization.formOrganization.form.input-label.distributed-by-parent'),
      //     },
      //   ]
      // }
    },
  },
  computed: {
    ...mapGetters({
      hasSessionPermission: 'auth/hasSessionPermission',
    }),

    isSendit() {
      return this.$store.getters['auth/isSendit']
    },

    currentRouteName() {
      return this.$route.name
    },

    isValid() {
      return !this.$v.organization.$invalid
    },

    optionsCountries() {
      return CallingCodeMoreFlag(this)
    },

    optionsBusinnesArea() {
      const newArr = this.optionsBusinnes.map((item) => {
        return { value: item.value, label: item.label }
      })
      return newArr
    },

    organizationUserId() {
      return this.$store.state.auth.organizationUserId
    },

    hasValueOrganizationTypeClient() {
      return this.valueOrganizationType == 'Client' || !this.organizationUserId
    },

    isShow() {
      //org client raiz
      if (this.isOrgRoot) {
        //edicao de org
        if (this.$route.name == 'mainOrganization') {
          return false
        }

        //criacao de subOrg filha de org cliente raiz, usando user sendit
        if (this.$route.name == 'createSubOrganization' && this.isSendit) {
          return true
        }
      }

      //criacao de subOrg filha de org sendit, usando user sendit
      if (this.$route.name == 'createSubOrganization' && this.isSendit) {
        return false
      }

      //criacao de Org raiz
      if (this.$route.name == 'createOrganization') {
        return false
      }

      return true
    },

    canUserDeleteOrganization() {
      return this.hasSessionPermission('Organization_Delete')
    }
  },
  validations: {
    organization: {
      companyName: {
        required,
        maxLength: maxLength(255),
      },
      phoneCountryIndicator: {
        required,
      },
      phoneNumber: {
        required,
        maxLength: maxLength(16),
      },
      email: {
        required,
        email,
      },
      organizationType: {
        required: requiredIf(function () {
          return this.$route.params.organizationId
        }),
      },
      businessArea: {
        required,
      },
      organizationBalanceConfigType: {
        required: requiredIf(function () {
          return this.$route.params.organizationId
        }),
      },
      businessProfile: {
        required,
      },
      contactEmail: {
        required,
        email,
      },
      contactName: {
        required,
        maxLength: maxLength(255),
      },
      contactPhoneCountryIndicator: {
        required,
      },
      contactPhoneNumber: {
        required,
        maxLength: maxLength(16),
      },
      contactFinancialEmail: {
        email,
      },
      contactFinancialName: {},
      contactFinancialPhoneCountryIndicator: {},
      contactFinancialPhoneNumber: {
        maxLength: maxLength(16),
      },
      contactITEmail: {
        email,
      },
      contactITName: {},
      contactITPhoneCountryIndicator: {},
      contactITPhoneNumber: {
        maxLength: maxLength(16),
      },
      isUsingParentBillingInfo: {},
      billingInfo: {
        name: {
          required,
        },
        email: {
          email,
          required,
        },
        taxIdentificationNumber: {
          required,
          numeric,
          maxLength: maxLength(20),
        },
        address: {
          required,
          maxLength: maxLength(255),
        },
        postalCode: {
          required,
          maxLength: maxLength(20),
        },
        country: {
          required,
        },
        city: {
          required,
          maxLength: maxLength(50),
        },
        phoneCountryIndicator: {
          required,
        },
        phoneNumber: {
          required,
          maxLength: maxLength(16),
        },
      },
    },
  },
  watch: {
    // Utilizado para verificar quando a ação de cancelar for invocada
    edit: function (newValue, oldValue) {
      if (!newValue && oldValue) {
        this.organization = JSON.parse(JSON.stringify(this.organizationAux))
        this.$v.$reset()
      }
    },
  },

  mounted() {
    if (this.$store.state.auth.organizationId) {
      this.getInfoorganization()
    }

    this.organizationId = this.$store.state.auth.organizationId
    if (this.currentRouteName == 'createSubOrganization') {
      this.organization.parentOrganizationId = this.$store.state.auth.organizationId
    }

    this.getBusinessProfile(() => {
      this.getBusiness(() => {
        if (this.$store.state.auth.organizationId) {
          this.getOrganizationTypes(() => {
            if (this.isEdit) {
              this.loadOrganization()
            } else {
              this.loadParentOrganizationInfo()
            }
          })
        }
      })
    })

    this.optionsCountriesNames = nameCountries(this)
    this.optionsCountriesNames.push(
      {
        flag: '/img/flags/pt.svg',
        label: this.$t(`general.components.selects.countries.Portugal_Acores`),
        value: 'PT',
        detailCountry: 'acores',
        vies: false,
      },
      {
        flag: '/img/flags/pt.svg',
        label: this.$t(`general.components.selects.countries.Portugal_Madeira`),
        value: 'PT',
        detailCountry: 'madeira',
        vies: false,
      },
    )
  },
}
</script>

<style>
.border-line {
  border-bottom: 1px solid #d1d4da;
}
</style>
